module.exports = __webpack_public_path__ + "static/media/benefit-image.b319ecb6.jpg";